import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const OrganizationalHierarchy = () => {
  const [expandedRegions, setExpandedRegions] = useState({});
  const [selectedLevel, setSelectedLevel] = useState('all');

  const hierarchyData = {
    national: {
      name: 'Ghana Health Service',
      code: 'GHS-NAT-001',
      level: 'National',
      facilities: 3842,
      population: 31072945,
      regions: [
        {
          id: 'greater-accra',
          name: 'Greater Accra Region',
          code: 'GHS-GAR-001',
          facilities: 487,
          population: 5455692,
          districts: [
            { name: 'Accra Metropolitan', code: 'GHS-GAR-AMA', facilities: 142, population: 1848614 },
            { name: 'Tema Metropolitan', code: 'GHS-GAR-TMA', facilities: 89, population: 402637 },
            { name: 'Ga East Municipal', code: 'GHS-GAR-GEM', facilities: 67, population: 259668 },
            { name: 'Ga West Municipal', code: 'GHS-GAR-GWM', facilities: 54, population: 262742 },
            { name: 'Ga South Municipal', code: 'GHS-GAR-GSM', facilities: 48, population: 411377 },
            { name: 'Ga Central Municipal', code: 'GHS-GAR-GCM', facilities: 42, population: 117185 },
            { name: 'Ledzokuku Municipal', code: 'GHS-GAR-LM', facilities: 45, population: 227932 }
          ]
        },
        {
          id: 'ashanti',
          name: 'Ashanti Region',
          code: 'GHS-ASH-002',
          facilities: 612,
          population: 5440463,
          districts: [
            { name: 'Kumasi Metropolitan', code: 'GHS-ASH-KMA', facilities: 178, population: 2035064 },
            { name: 'Obuasi Municipal', code: 'GHS-ASH-OM', facilities: 72, population: 175043 },
            { name: 'Ejisu Municipal', code: 'GHS-ASH-EM', facilities: 58, population: 143762 },
            { name: 'Asokore Mampong Municipal', code: 'GHS-ASH-AMM', facilities: 51, population: 155182 },
            { name: 'Bosomtwe District', code: 'GHS-ASH-BD', facilities: 44, population: 93910 },
            { name: 'Atwima Nwabiagya Municipal', code: 'GHS-ASH-ANM', facilities: 62, population: 149025 }
          ]
        },
        {
          id: 'western',
          name: 'Western Region',
          code: 'GHS-WES-003',
          facilities: 398,
          population: 2865228,
          districts: [
            { name: 'Sekondi-Takoradi Metropolitan', code: 'GHS-WES-STMA', facilities: 124, population: 559548 },
            { name: 'Tarkwa-Nsuaem Municipal', code: 'GHS-WES-TNM', facilities: 67, population: 98872 },
            { name: 'Shama District', code: 'GHS-WES-SD', facilities: 42, population: 88876 },
            { name: 'Ahanta West Municipal', code: 'GHS-WES-AWM', facilities: 54, population: 119345 },
            { name: 'Wassa East District', code: 'GHS-WES-WED', facilities: 48, population: 87065 }
          ]
        },
        {
          id: 'eastern',
          name: 'Eastern Region',
          code: 'GHS-EAS-004',
          facilities: 445,
          population: 2916806,
          districts: [
            { name: 'New Juaben Municipal', code: 'GHS-EAS-NJM', facilities: 98, population: 183727 },
            { name: 'Akuapem North Municipal', code: 'GHS-EAS-ANM', facilities: 72, population: 118233 },
            { name: 'Suhum Municipal', code: 'GHS-EAS-SM', facilities: 58, population: 90358 },
            { name: 'Kwahu West Municipal', code: 'GHS-EAS-KWM', facilities: 64, population: 96557 },
            { name: 'Birim Central Municipal', code: 'GHS-EAS-BCM', facilities: 54, population: 144869 }
          ]
        },
        {
          id: 'northern',
          name: 'Northern Region',
          code: 'GHS-NOR-005',
          facilities: 324,
          population: 2479461,
          districts: [
            { name: 'Tamale Metropolitan', code: 'GHS-NOR-TMA', facilities: 112, population: 371351 },
            { name: 'Yendi Municipal', code: 'GHS-NOR-YM', facilities: 54, population: 117780 },
            { name: 'Savelugu Municipal', code: 'GHS-NOR-SM', facilities: 48, population: 139283 },
            { name: 'Kumbungu District', code: 'GHS-NOR-KD', facilities: 38, population: 99519 },
            { name: 'Tolon District', code: 'GHS-NOR-TD', facilities: 42, population: 84229 }
          ]
        },
        {
          id: 'central',
          name: 'Central Region',
          code: 'GHS-CEN-006',
          facilities: 367,
          population: 2859821,
          districts: [
            { name: 'Cape Coast Metropolitan', code: 'GHS-CEN-CCMA', facilities: 94, population: 169894 },
            { name: 'Komenda-Edina-Eguafo-Abirem Municipal', code: 'GHS-CEN-KEEAM', facilities: 62, population: 144705 },
            { name: 'Abura-Asebu-Kwamankese District', code: 'GHS-CEN-AAKD', facilities: 48, population: 121843 },
            { name: 'Mfantseman Municipal', code: 'GHS-CEN-MM', facilities: 56, population: 144332 }
          ]
        },
        {
          id: 'volta',
          name: 'Volta Region',
          code: 'GHS-VOL-007',
          facilities: 289,
          population: 2118252,
          districts: [
            { name: 'Ho Municipal', code: 'GHS-VOL-HM', facilities: 78, population: 177281 },
            { name: 'Keta Municipal', code: 'GHS-VOL-KM', facilities: 54, population: 147618 },
            { name: 'Hohoe Municipal', code: 'GHS-VOL-HHM', facilities: 62, population: 167016 },
            { name: 'Kpando Municipal', code: 'GHS-VOL-KPM', facilities: 48, population: 95658 }
          ]
        },
        {
          id: 'upper-east',
          name: 'Upper East Region',
          code: 'GHS-UE-008',
          facilities: 267,
          population: 1301221,
          districts: [
            { name: 'Bolgatanga Municipal', code: 'GHS-UE-BM', facilities: 84, population: 131550 },
            { name: 'Bawku Municipal', code: 'GHS-UE-BWM', facilities: 68, population: 98538 },
            { name: 'Kassena-Nankana Municipal', code: 'GHS-UE-KNM', facilities: 52, population: 109944 },
            { name: 'Builsa North District', code: 'GHS-UE-BND', facilities: 38, population: 61673 }
          ]
        },
        {
          id: 'upper-west',
          name: 'Upper West Region',
          code: 'GHS-UW-009',
          facilities: 198,
          population: 858093,
          districts: [
            { name: 'Wa Municipal', code: 'GHS-UW-WM', facilities: 72, population: 102446 },
            { name: 'Lawra Municipal', code: 'GHS-UW-LM', facilities: 44, population: 94950 },
            { name: 'Jirapa Municipal', code: 'GHS-UW-JM', facilities: 48, population: 88402 },
            { name: 'Nadowli-Kaleo District', code: 'GHS-UW-NKD', facilities: 34, population: 94388 }
          ]
        },
        {
          id: 'bono',
          name: 'Bono Region',
          code: 'GHS-BON-010',
          facilities: 255,
          population: 1208649,
          districts: [
            { name: 'Sunyani Municipal', code: 'GHS-BON-SM', facilities: 89, population: 123224 },
            { name: 'Berekum Municipal', code: 'GHS-BON-BM', facilities: 58, population: 129628 },
            { name: 'Dormaa Municipal', code: 'GHS-BON-DM', facilities: 62, population: 112111 },
            { name: 'Tain District', code: 'GHS-BON-TD', facilities: 46, population: 90042 }
          ]
        }
      ]
    }
  };

  const toggleRegion = (regionId) => {
    setExpandedRegions(prev => ({
      ...prev,
      [regionId]: !prev?.[regionId]
    }));
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US')?.format(num);
  };

  const filteredRegions = selectedLevel === 'all' 
    ? hierarchyData?.national?.regions 
    : hierarchyData?.national?.regions;

  return (
    <div className="bg-background">
      <div className="main-content">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Network" size={24} color="#3B82F6" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-text-primary">Organizational Hierarchy</h1>
                <p className="text-sm text-text-secondary">Ghana Health Service Structure - National to District Level</p>
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                variant={selectedLevel === 'all' ? 'default' : 'outline'}
                onClick={() => setSelectedLevel('all')}
                size="sm"
              >
                All Levels
              </Button>
              <Button
                variant={selectedLevel === 'regional' ? 'default' : 'outline'}
                onClick={() => setSelectedLevel('regional')}
                size="sm"
              >
                Regional
              </Button>
            </div>
          </div>

          <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg p-6 border border-primary/20">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center">
                <Icon name="Building2" size={32} color="#3B82F6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-text-primary">{hierarchyData?.national?.name}</h2>
                <p className="text-sm text-text-secondary">{hierarchyData?.national?.code}</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-surface/50 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="MapPin" size={18} color="#3B82F6" />
                  <span className="text-sm text-text-secondary">Regions</span>
                </div>
                <p className="text-2xl font-bold text-text-primary">{hierarchyData?.national?.regions?.length}</p>
              </div>
              <div className="bg-surface/50 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Building" size={18} color="#10B981" />
                  <span className="text-sm text-text-secondary">Total Facilities</span>
                </div>
                <p className="text-2xl font-bold text-text-primary">{formatNumber(hierarchyData?.national?.facilities)}</p>
              </div>
              <div className="bg-surface/50 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Users" size={18} color="#F59E0B" />
                  <span className="text-sm text-text-secondary">Population Served</span>
                </div>
                <p className="text-2xl font-bold text-text-primary">{formatNumber(hierarchyData?.national?.population)}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-text-primary flex items-center gap-2">
            <Icon name="Map" size={20} />
            Regional Breakdown
          </h3>
          {filteredRegions?.map((region) => (
            <div key={region?.id} className="bg-surface rounded-lg shadow-md overflow-hidden border border-border">
              <div
                className="p-4 cursor-pointer hover:bg-surface-hover transition-colors"
                onClick={() => toggleRegion(region?.id)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name="MapPin" size={20} color="#3B82F6" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-text-primary">{region?.name}</h4>
                      <p className="text-sm text-text-secondary">{region?.code}</p>
                    </div>
                    <div className="hidden md:flex gap-6">
                      <div className="text-center">
                        <p className="text-xs text-text-secondary">Districts</p>
                        <p className="text-sm font-semibold text-text-primary">{region?.districts?.length}</p>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-text-secondary">Facilities</p>
                        <p className="text-sm font-semibold text-text-primary">{formatNumber(region?.facilities)}</p>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-text-secondary">Population</p>
                        <p className="text-sm font-semibold text-text-primary">{formatNumber(region?.population)}</p>
                      </div>
                    </div>
                  </div>
                  <Icon
                    name={expandedRegions?.[region?.id] ? 'ChevronUp' : 'ChevronDown'}
                    size={20}
                    className="text-text-secondary"
                  />
                </div>
              </div>

              {expandedRegions?.[region?.id] && (
                <div className="border-t border-border bg-background/50 p-4">
                  <h5 className="text-sm font-semibold text-text-primary mb-3 flex items-center gap-2">
                    <Icon name="Building" size={16} />
                    District Level
                  </h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {region?.districts?.map((district, idx) => (
                      <div
                        key={idx}
                        className="bg-surface rounded-lg p-3 border border-border hover:border-primary/30 transition-colors"
                      >
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-success/10 rounded flex items-center justify-center flex-shrink-0">
                            <Icon name="MapPin" size={16} color="#10B981" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-medium text-text-primary text-sm truncate">{district?.name}</h6>
                            <p className="text-xs text-text-secondary mb-2">{district?.code}</p>
                            <div className="flex gap-4">
                              <div>
                                <p className="text-xs text-text-secondary">Facilities</p>
                                <p className="text-sm font-semibold text-text-primary">{district?.facilities}</p>
                              </div>
                              <div>
                                <p className="text-xs text-text-secondary">Population</p>
                                <p className="text-sm font-semibold text-text-primary">{formatNumber(district?.population)}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrganizationalHierarchy;
